module.exports = __webpack_public_path__ + "assets/img/icon_tabnav_02_on.f143e4f8.png";